export class ResetAccountModel {
    public key: string;
    public secret: string;
    public password: string;
    public confirm: string;
}



// WEBPACK FOOTER //
// ./src/models/account/account.reset.model.ts